import React from "react";
import PropTypes from "prop-types";
import { Message, Flex, Text } from "samba-ui";
import { StyledMainContainer } from "./styles";

const SuccessMessage = ({ successMessage }) => (
  <StyledMainContainer>
    <Message variant="success" py={3}>
      <Flex flexDirection="column">
        <Text color="#212530" fontWeight="500" mb={1}>
          {successMessage}
        </Text>
        <Text color="#212530">
          Please allow 72 hours before the first delivery.
        </Text>
      </Flex>
    </Message>
  </StyledMainContainer>
);

SuccessMessage.propTypes = {
  successMessage: PropTypes.string
};

export default SuccessMessage;
